<template>
  <!-- Pegado a la lista de «Servicios», debajo del aviso de códigos huérfanos y por lo mismo: lo
       que hay que revisar es esa lista, así que el aviso va donde está (§9 del CLAUDE.md del
       orquestador). Si no hay nada que decir no se dibuja nada. -->
  <div v-if="avisos.length" class="col-100 marcado-aviso">
    <div v-for="(aviso, i) in avisos" :key="'av-' + i" class="marcado-cuerpo">
      <template v-if="aviso.tipo == 'MARCADO_MASIVO'">
        <div class="marcado-titulo">
          ⚠️
          {{ $t('empleados.avisoServicios.masivoTitulo', {
            n: aviso.serviciosMarcados,
            catalogo: (aviso.plantilla && aviso.plantilla.tamanoCatalogo) || 0
          }) }}
        </div>
        <!-- Con qué se compara, en el propio aviso: «555 servicios» no se puede juzgar sin saber
             cuántos tiene el resto de la plantilla. -->
        <div class="marcado-motivo" v-if="aviso.plantilla && aviso.plantilla.mediana != null">
          {{ $t('empleados.avisoServicios.masivoPlantilla', {
            mediana: aviso.plantilla.mediana,
            maximo: aviso.plantilla.maximo,
            fichas: aviso.plantilla.fichasConServicios
          }) }}
        </div>
        <div class="marcado-motivo">{{ $t('empleados.avisoServicios.masivoPorque') }}</div>
        <!-- El quién y el dónde, como el aviso de huérfanos: el aviso tiene que poder accionarse
             leyéndolo. Y dice explícitamente que lo guardado se ha guardado, para que nadie crea
             que el cambio no ha entrado. -->
        <div class="marcado-motivo">{{ $t('empleados.avisoServicios.masivoQuien') }}</div>
      </template>
      <template v-else-if="aviso.tipo == 'SIN_SERVICIOS'">
        <div class="marcado-titulo">⚠️ {{ $t('empleados.avisoServicios.sinServiciosTitulo') }}</div>
        <div class="marcado-motivo">{{ $t('empleados.avisoServicios.sinServiciosPorque') }}</div>
        <div class="marcado-motivo">{{ $t('empleados.avisoServicios.sinServiciosQuien') }}</div>
      </template>
    </div>
  </div>
</template>
<style scoped>
.marcado-aviso {
  margin: 0 8px 8px;
  font-size: 13px;
}
.marcado-cuerpo {
  border-left: 3px solid #ff9500;
  padding-left: 8px;
}
.marcado-cuerpo + .marcado-cuerpo {
  margin-top: 6px;
}
.marcado-titulo {
  color: #ff9500;
  font-weight: bold;
}
.marcado-motivo {
  margin-top: 2px;
}
</style>
<script>
/**
 * Aviso del número de servicios marcados en la ficha de inspector (#305).
 *
 * No consulta nada: pinta lo que ha contestado el guardado (`avisosServicios` de la respuesta de
 * guardar el empleado). Por eso aparece **al guardar** y no al abrir la ficha, que es lo que pidió
 * dirección: un marcado masivo es casi siempre algo que alguien acaba de hacer, y el retrato de qué
 * fichas lo tienen hoy sale de la conciliación del censo, que es una consulta aparte.
 *
 * Tampoco ofrece ningún botón que corrija la ficha: la cualificación de una persona la decide
 * dirección técnica, y la regla de la #305 es que ninguna ficha se modifica sin su confirmación.
 */
export default {
  props: {
    avisos: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
